var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSpinner = function SvgSpinner(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 13,
    "data-width-24": 16,
    "data-width-40": 27,
    "data-width-72": 59,
    viewBox: "0 0 13 12",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.987 6.5c.56 0 1.021-.456.934-1.01A6.5 6.5 0 0 0 5.99.02a6.5 6.5 0 0 0-2.448.692c-.498.255-.596.896-.267 1.35.329.452.96.54 1.476.321a4.473 4.473 0 0 1 6.108 3.112c.126.546.568 1.005 1.128 1.005"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSpinner);
export default ForwardRef;